export const PAGE_LIMIT = 100;
export const PARAMS = [["sp","Spends"],["i","Impressions"],["aI","AK Impressions"],["c","AK Clicks"],["aSp","AK Spend"],["r","Revenues"],["oR","Onw Revenues"],["tR","Total Revenues"],["ro","Roi", 'roi'],["pRo","ROI %"],["dsc","DISC"]];


// WEBPACK FOOTER //
// ./src/scenes/AkFull/config.js